/**
 * VisuallyHidden Component
 *
 * Hides content visually while keeping it accessible to screen readers.
 */

import React from "react";

const VisuallyHidden = ({ children, as: Component = "span" }) => {
  return (
    <Component className="visually-hidden">{children}</Component>
  );
};

export default VisuallyHidden;
